import { sample } from 'effector';
import { throttle, delay } from 'patronum';
import {
  changedEvent,
  refreshTicketList,
  updateTicketList,
  $timeoutTicketsRefresh,
  changeTimeoutRefresh,
  resetTimeoutRefresh
} from './page.model';

const TIMEOUT = 60000;
const TICKETS_REFRESH = 'tickets:refresh';

$timeoutTicketsRefresh
  .on(changeTimeoutRefresh, () => TIMEOUT)
  .reset(resetTimeoutRefresh);

/* Аккумулирую в одно событие по таймату,
  если не было предыдущих вызовов, то срабатывает сразу */
const throttledRefresh = throttle({
  source: refreshTicketList,
  timeout: $timeoutTicketsRefresh,
});

const delayedResetTimeoutRefresh = delay({
  source: changeTimeoutRefresh,
  timeout: TIMEOUT,
});

/* changedEvent может сработать десятки раз в секунду */
sample({
  clock: changedEvent,
  filter: ({ event }) => event === TICKETS_REFRESH,
  target: refreshTicketList
});

/* После вызова устанавливаю таймаут в TIMEOUT, что бы не спамить бэк */
sample({
  clock: throttledRefresh,
  target: [updateTicketList, changeTimeoutRefresh]
});

/* Сброс таймера, что бы после долгого затишья сразу обновить список заявок */
sample({
  clock: delayedResetTimeoutRefresh,
  target: resetTimeoutRefresh
});
